import {
  Button,
  ButtonsContainer,
  ResponsiveSanityImage,
  ResponsiveSanityImageProps,
  SanityImageRatio
} from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./HighlightedCruiseGroupCard.module.scss";
import { Trans } from "@lingui/react/macro";
import clsx from "clsx";
type Props = {
  title?: string;
  content?: string;
  image?: ResponsiveSanityImageProps["image"];
  url?: string;
  trackingName?: string;
  className?: string;
};

const HighlightedCruiseGroupCard: React.FC<Props> = ({
  title,
  content,
  image,
  url,
  trackingName,
  className
}) => {
  return (
    <div
      className={clsx(styles.card, className)}
      data-content-name={trackingName}
    >
      <SanityImageRatio ratio="auto" image={image}>
        <ResponsiveSanityImage
          image={image}
          defaultWidth={500}
          defaultHeight={260}
          className={styles.image}
          alt={title}
        />
      </SanityImageRatio>

      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        <div>{content}</div>
        <ButtonsContainer mobileFullSize align="left">
          <Button
            renderAs="a"
            href={url}
            variant="secondary"
            dataContentPiece="more_button"
          >
            <Trans id="cta-discover-more">Discover more</Trans>
          </Button>
        </ButtonsContainer>
      </div>
    </div>
  );
};

export default HighlightedCruiseGroupCard;
